import React, { useState, useContext, useEffect } from "react";
import Section from "../../UIcomponent/Section";
import "./TeacherRegister.scss";
import Col from "../../UIcomponent/Column";
import LocalContext from "../../Context/LocalContetxt";
import LoginRegisterContext from "../../Context/LoginRegisterContext";
import DateTime from "../../Utility/Method/DateTime";
import LoginRegisterReq from "../../Utility/Requester/LoginRegisterReq";
import LocalToken from "../../Utility/Method/LocalToken";
import { Formik } from "formik";
import { StyledForm } from "../../UIcomponent/Form";
import { ThemeContext } from "styled-components";
import { TeacherRegisterSchema } from "../../Utility/ValidationSchema";
import TeacherRegisterForm from "./TeacherRegisterForm";
import PhoneNumber from "../../Utility/Method/PhoneNumber";
import { Notify } from "../../UIcomponent/NotificationManager";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import LocalAppConfig from "../../Utility/Method/LocalAppConfig";
const TeacherRegister = (props) => {
  const lang = useContext(LocalContext).lang;
  const InfoCtxt = useContext(LoginRegisterContext);
  const localCtxt = useContext(LocalContext);
  const theme = useContext(ThemeContext);
  const appConfig = LocalAppConfig.Get();
  const languages = appConfig.Language || {};

  const codeExpireDuration = 120 * 1000;
  const [State, setState] = useState({
    flowType: "mobile",
    mode: "register",
    expireTime: codeExpireDuration,
    hasVerifyCode: false,
    verifyCodeStatus: false,
    shake: false,
  });
  const [info, setInfo] = useState({
    PhoneNumber: "",
    VerifiedID: "",
    FirstName: "",
    LastName: "",
    Code: "",
    phoneCode: "+98",
    timeZone: DateTime.timeZone(),
  });
  const [redirect, setRedirect] = useState(false);
  const formErrosStyle = (justifyContent) => {
    return {
      display: "flex",
      justifyContent: justifyContent || "flex-start",
      backgroundColor: "white",
      minHeight: "15px",
      maxHeight: "15px",
      color: theme.danger,
      borderRadius: "5px",
      alignSelf: "flex-start",
      fontFamily: "Fa_IRANSans",
      fontSize: theme.fontSizeXs,
      fontWeight: 600,
    };
  };
  const RegisterFormEdit = () => {
    setState({
      ...State,
      mode: "register",
      hasVerifyCode: false,
    });
  };
  useEffect(() => {}, []);

  const ResendCode = (actions, values) => {
    let Body;
    actions.setSubmitting(true);
    if (State.flowType === "mobile") {
      Body = {
        PhoneNumber: PhoneNumber.CodeHandler(values.mobile, values.phoneCode),
      };
      return LoginRegisterReq.SendPhoneVerifyCode(Body)
        .then((res) => {
          actions.setSubmitting(false);
          setState({
            ...State,
            hasVerifyCode: true,
            expireTime: Date.now() + codeExpireDuration,
          });
          // setRedirect(true)
          // setTimeout(() => {
          //     localCtxt.setHasToken(true)
          // }, 1)
          // setTimeout(() => {
          // }, 0)
        })
        .catch((err) => {
          actions.setSubmitting(false);
          Notify("error", err.response.data.message);
        });
    }
  };
  return (
    <LoginRegisterContext.Provider
      value={{
        info,
        setInfo,
      }}
    >
      {redirect === true && (
        <Redirect
          to={{
            pathname: "/dashboard",
            state: { teacherRegistered: true },
          }}
        />
      )}
      <Section
        className={`l__LoginRegister ${
          State.shake === true && "l__LoginRegister--Shake"
        } `}
      >
        <Formik
          enableReinitialize={true}
          validationSchema={TeacherRegisterSchema(info.phoneCode)}
          isInitialValid={true}
          initialValues={{
            mobile: "",
            pass: "",
            phoneCode: InfoCtxt.info.phoneCode,
            firstName: "",
            lastName: "",
            code: "",
            timezone: InfoCtxt.info.timeZone,
            language: "English",
          }}
          isSubmitting={false}
          onSubmit={(values, actions) => {
            let Language = 1;
            if (values.language) {
              Object.keys(languages).map((key) => {
                if (languages[key] == values.language) {
                  Language = parseInt(key);
                }
              });
            }
            if (State.mode === "register" && State.hasVerifyCode === false) {
              let Body;
              actions.setSubmitting(true);
              if (State.flowType === "mobile") {
                Body = {
                  PhoneNumber: PhoneNumber.CodeHandler(
                    values.mobile,
                    values.phoneCode
                  ),
                };
                return LoginRegisterReq.SendPhoneVerifyCode(Body)
                  .then((res) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      hasVerifyCode: true,
                      expireTime: Date.now() + codeExpireDuration,
                    });
                    // setRedirect(true)
                    // setTimeout(() => {
                    //     localCtxt.setHasToken(true)
                    // }, 1)
                    // setTimeout(() => {
                    // }, 0)
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              }
            } else if (State.mode === "register" && State.expireTime === null) {
              let Body;
              actions.setSubmitting(true);
              if (State.flowType === "mobile") {
                Body = {
                  PhoneNumber: PhoneNumber.CodeHandler(
                    values.mobile,
                    values.phoneCode
                  ),
                };
                return LoginRegisterReq.SendPhoneVerifyCode(Body)
                  .then((res) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      hasVerifyCode: true,
                      expireTime: Date.now() + codeExpireDuration,
                    });
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              }
            } else if (
              State.mode === "register" &&
              State.hasVerifyCode === true &&
              State.expireTime !== null
            ) {
              if (State.flowType === "mobile") {
                localStorage.clear();
                let Data = {
                  PhoneNumber: PhoneNumber.CodeHandler(
                    values.mobile,
                    values.phoneCode
                  ),
                  Code: values.code,
                };
                LoginRegisterReq.PhoneVerifyCode(Data)
                  .then((Res) => {
                    let Body = {
                      PhoneNumber: PhoneNumber.CodeHandler(
                        values.mobile,
                        values.phoneCode
                      ),
                      VerifiedID: Res.data.VerifiedID,
                      Password: values.pass,
                      FirstName: values.firstName,
                      LastName: values.lastName,
                      TimeZone: values.timezone,
                      Language,
                    };
                    LoginRegisterReq.TeacherRegisterByPhone(Body)
                      .then((res) => {
                        actions.setSubmitting(false);
                        setState({
                          ...State,
                          hasVerifyCode: true,
                        });
                        LocalToken.Set(res);

                        Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
                        Cookies.set(
                          "LINGO_REFRESH_TOKEN",
                          res.data.RefreshToken
                        );
                        setTimeout(() => {
                          localCtxt.setHasToken(true);
                        }, 1);
                        setTimeout(() => {
                          setRedirect(true);
                        }, 2);
                      })
                      .catch((err) => {
                        err.response &&
                          Notify("error", err.response.data.message);
                        actions.setSubmitting(false);
                      });
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    err.response &&
                      setState({
                        ...State,
                        shake: true,
                      });
                    err.response && Notify("error", err.response.data.message);
                    actions.setFieldValue("code", "");
                  });
              }
            }
          }}
        >
          {(formik) => (
            <StyledForm
              style={{
                padding: "15px 0px 15px 0px",
              }}
              onSubmit={formik.handleSubmit}
            >
              <Col xl={20} lg={22} md={22} sm={22} xs={22} className="c__Form">
                {State.mode === "register" && (
                  <TeacherRegisterForm
                    State={State}
                    setState={setState}
                    info={info}
                    setInfo={setInfo}
                    lang={lang}
                    localCtxt={localCtxt}
                    flowType={State.flowType}
                    formikProps={formik}
                    formik={formik}
                    RegisterFormEdit={RegisterFormEdit}
                    formErrosStyle={formErrosStyle}
                    ResendCode={ResendCode}
                  />
                )}
              </Col>
            </StyledForm>
          )}
        </Formik>
      </Section>
    </LoginRegisterContext.Provider>
  );
};

export default TeacherRegister;
